import * as React from "react";
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const CustomButton = styled(Button)(({ theme }) => ({
  borderRadius: "20px",
  color: "#ffffff",
  fontSize: "13px",
  textTransform: "none",
  backgroundColor: "#36899f",
  fontWeight: "bold",
  padding: "10px",
  width: "100%",
  '&:hover': {
    backgroundColor: "#36899f",
    boxShadow: "none",
  },
  boxShadow: "none"
}));

const YellowButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: "#ddb930",
  '&:hover': {
    backgroundColor: "#ddb930",
  },
}));

const YellowBigButton = styled(CustomButton)(({ theme }) => ({
  height: "60px",
  backgroundColor: "#ddb930",
  '&:hover': {
    backgroundColor: "#ddb930",
  },
}));

const GrayButton = styled(CustomButton)(({ theme }) => ({
  height: "60px",
  backgroundColor: "#3E3C4C",
  '&:hover': {
    backgroundColor: "#3E3C4C",
  },
}));
interface signButtonProps {
  color: string,
  text: string,
  size?: string,
  type?: "button" | "reset" | "submit",
  disabled?: boolean,
}

const SignButton: React.FC<signButtonProps> = ({ color, text, size, type, disabled }) => {
  const page = require('assets/page.png');
  return (
    color === "sky" ? <CustomButton variant="contained" type={type} disabled={disabled}>{text}</CustomButton>
      : color === "yellow" ? (size === "big" ? <YellowBigButton variant="contained" type={type} disabled={disabled}>{text}</YellowBigButton> : <YellowButton variant="contained" type={type} disabled={disabled}>{text}</YellowButton>)
        : <GrayButton type={type} disabled={disabled} endIcon={<img src={page} style={{ marginBottom: "3px" }} alt={"img"}/>} variant="contained">{text}</GrayButton>
  );
}

export default SignButton;